module.exports = __webpack_public_path__ + "static/media/rocket.a93bf78c.svg";